
export const whoIsItForList = [
  "Companies from the blockchain, crypto, NFT, Metaverse space",
  "Brands",
  "Agencies",
];

